'use client';
import { usePathname } from 'next/navigation';
import { Footer } from './Footer';

export function FooterWrapper() {
  const pathname = usePathname();
  if (pathname.startsWith('/admin')) return null;
  if (pathname.startsWith('/labs')) return null; // style prototypes render their own footer
  if (pathname.startsWith('/delivery')) return null; // персональна видача — самостійна сторінка без сайтового chrome
  return <Footer />;
}
